import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import moment from "moment";
import numeral from "numeral"
import "numeral/locales"

import apiClient from "./api/OpenClient"

import language_de_DE from './string_resources/de_DE/translate.json'
import language_en_GB from './string_resources/en_GB/translate.json'
import language_en_US from './string_resources/en_US/translate.json'
import language_fi_FI from './string_resources/fi_FI/translate.json'
import language_sv_SE from './string_resources/sv_SE/translate.json'
import language_es_419 from './string_resources/es_419/translate.json'
import langauge_fr_CA from './string_resources/fr_CA/translate.json'
// import langauge_no_NO from './string_resources/no_NO/translate.json'
// import langauge_da_DK from './string_resources/da_DK/translate.json'
// import langauge_nl_NL from './string_resources/nl_NL/translate.json'
// import langauge_it_IT from './string_resources/it_IT/translate.json'
// import langauge_pt_PT from './string_resources/pt_PT/translate.json'

import {enableBrowserLanguageCheck} from "./AppSettings";

import { ChooseBestSupportedLanguage, SupportedLanguagesMap } from './LanguageSupport'

import qs from "qs";

const resources = {
    // Languages with regions
    de_DE: language_de_DE,
    en_GB: language_en_GB,
    en_US: language_en_US,
    fi_FI: language_fi_FI,
    sv_SE: language_sv_SE,
    es_419: language_es_419,
    fr_CA: langauge_fr_CA,
    // no_NO: langauge_no_NO,
    // da_DK: langauge_da_DK,
    // nl_NL: langauge_nl_NL,
    // it_IT: langauge_it_IT,
    // pt_PT: langauge_pt_PT,

    // Region-less languages
    de: language_de_DE,
    en: language_en_US,
    fi: language_fi_FI,
    sv: language_sv_SE,
    es: language_es_419,
    fr: langauge_fr_CA,
    // no: langauge_no_NO,
    // da: langauge_da_DK,
    // nl: langauge_nl_NL,
    // it: langauge_it_IT,
    // pt: langauge_pt_PT,
};

// This is the default language
const DefaultLanguage = "en_US";


const GetBrowserLanguagePreference = async () => {

    if ( enableBrowserLanguageCheck() ) {
        const response = await apiClient.get("/language-detection");
        let acceptLanguage = response.data.AcceptLanguage;
        return ChooseBestSupportedLanguage(acceptLanguage);
    }

    return DefaultLanguage;
}


const getLangCodeForAudio = async () => {
  // If we don't support the user's region language, this function returns a region-less code
  const language = i18n.language;

  // Temporary. 3.1. Use American accented audio for the UK.
  if (language === "en_GB") {
      return DefaultLanguage
  }

  if (SupportedLanguagesMap[language]) {
    return SupportedLanguagesMap[language];
  }

  return DefaultLanguage
}


if( numeral["locales"]["en_us"]) {
    // This code gets executed twice when running the dashboard.  Only run once,
    // so that a TypeError exception is not thrown
    //
    // console.log("Already registered");
} else {

    // Numeral is missing en-us by default, so we can just add it here.
    numeral.register('locale', 'en_US', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                    (b === 2) ? 'nd' :
                        (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

}

i18n
    .use(initReactI18next)
    .init({
        resources,

        lng: DefaultLanguage,
        fallbackLng: DefaultLanguage,

        // Use a separate namespace for each page and component containing localized strings.
        //
        // This array can be generated periodically with:
        //
        //        jq 'keys' translate.json | pbcopy
        ns: [
                "components.AdminGeneralDisclaimer",
                "components.AppToolbar",
                "components.ConfirmationDialog",
                "components.FailureDialog",
                "components.Footer",
                "components.SuccessDialog",
                "components.Unauthorized",
                "components.common",
                "components.locations.AddLocationCard",
                "components.locations.ConfirmDeleteLocationDialog",
                "components.locations.EditLocationCard",
                "components.locations.ListLocationsCard",
                "components.mugshot.FaceMeasurer.ChooseCameraDialog",
                "components.organizations.AddOrganizationCard",
                "components.organizations.ConfirmDeleteOrganizationDialog",
                "components.organizations.EditOrganizationCard",
                "components.organizations.ListOrganizationsCard",
                "components.patients.ListPatientsCard",
                "components.users.AddUserCard",
                "components.users.AssignLocationsTransferList",
                "components.users.DeleteUserConfirmDialog",
                "components.users.EditUserCard",
                "components.users.ListUsersCard",
                "pages.MaskSelector.nextGenScan.QuitScanDialog",
                "pages.MaskSelector.nextGenScan.ScanInstructions",
                "pages.MaskSelector.nextGenScan.VolumePage",
                "pages.MaskSelectorAdmin.AdminDashboard",
                "pages.MaskSelectorAdmin.EuF40NewMaskDialog",
                "pages.MaskSelectorAdmin.NewMaskDialog",
                "pages.MaskSelectorAdmin.PatientDetailDialog",
                "pages.MaskSelectorAdmin.PatientDetailDialogV2",
                "pages.MaskSelectorAdmin.TermsAndPrivacyModal",
                "pages.MaskSelectorTool.BreathingExercise",
                "pages.MaskSelectorTool.ChooseMaskSizingMethod",
                "pages.MaskSelectorTool.CompletePage",
                "pages.MaskSelectorTool.CompletionStep",
                "pages.MaskSelectorTool.FaceMeasurer",
                "pages.MaskSelectorTool.FaceScanner",
                "pages.MaskSelectorTool.Footer",
                "pages.MaskSelectorTool.Header",
                "pages.MaskSelectorTool.ManualPreamble",
                "pages.MaskSelectorTool.MaskSelection",
                "pages.MaskSelectorTool.MaskSelectorTool",
                "pages.MaskSelectorTool.MaskSizing",
                "pages.MaskSelectorTool.MugShotMaskSizing",
                "pages.MaskSelectorTool.NextGen.postProcessing",
                "pages.MaskSelectorTool.NoCameraAccessDialog",
                "pages.MaskSelectorTool.PatientInformation",
                "pages.MaskSelectorTool.PrivacyPolicy",
                "pages.MaskSelectorTool.RetryFaceScan",
                "pages.MaskSelectorTool.ScanHelpPage",
                "pages.MaskSelectorTool.ScanIconBar",
                "pages.MaskSelectorTool.ScanInstructions",
                "pages.MaskSelectorTool.ScanPrepPage",
                "pages.MaskSelectorTool.SizingScanPrepPage",
                "pages.MaskSelectorTool.StartPage",
                "pages.MaskSelectorTool.Support",
                "pages.NotFound",
                "pages.Unsubscribe",
                "recommendation_common",
                "survey_common",
                "validation_common"
        ],

        keySeparator: false,
        nsSeparator: ":",

        interpolation: {
            escapeValue: false,

            format: function(value, format, lng) {
                if (format === 'uppercase') {
                    return value.toUpperCase();
                }

                if(value instanceof Date) {
                    return moment.utc(value).format(format);
                } 

                return value;
            }
        },

        react: {
            useSuspense: true,
        }
    })

// Set the html lang attribute to current browsers language
i18n.on('languageChanged', () => {
    document.documentElement.setAttribute("lang", navigator.language)
});


const parseQueryParamLangOverride = (lang) => {

    const queryParams = qs.parse(window.location.search.substring(1));

    if(queryParams.lang) {
        switch(queryParams.lang.toLowerCase()) {
            case "de":
            case "de_de":
                i18n.changeLanguage("de_DE");
                break;

            case "en_gb":
                i18n.changeLanguage("en_GB")
                break;

            case "fi":
            case "fi_fi":
                i18n.changeLanguage("fi_FI");
                break;

            case "sv":
            case "sv_se":
                i18n.changeLanguage("sv_SE");
                break;

            case "en":
            case "en_us":
            default:
                i18n.changeLanguage("en_us");
                break;
        }
    }
    else {
        i18n.changeLanguage(lang);
    }

}

// Formats a number using the specified format and the current i18next language.
export const formatNumber = (number, format) => {
    switch(i18n.language.toLowerCase) {
        case "de":
        case "de_de":
            numeral.locale("de_DE");
            break;

        case "en_gb":
            numeral.locale("en_GB");
            break;

        case "en":
        case "en_us":
            numeral.locale("en_US");
            break;

        case "es":
        case "es_419":
            numeral.locale("es_419");
            break;

        case "fi":
        case "fi_fi":
            numeral.locale("fi_FI");
            break;

        case "fr":
        case "fr_CA":
            numeral.locale("fr_CA");
            break;

        case "sv":
        case "sv_se":
            numeral.locale("sv_SE");
            break;

        case "no":
        case "no_NO":
            numeral.locale("no_NO");
            break;

        case "da":
        case "da_DK":
            numeral.locale("da_DK");
            break;

        case "nl":
        case "nl_NL":
            numeral.locale("nl_NL");
            break;

        case "it":
        case "it_IT":
            numeral.locale("it_IT");
            break;

        case "pt":
        case "pt_PT":
            numeral.locale("pt_PT");
            break;

        default:
            numeral.locale("en_US");
            break;
    }

    return numeral(Number(number)).format(format);
};

export default i18n;

export {
    ChooseBestSupportedLanguage,
    GetBrowserLanguagePreference,
    DefaultLanguage,
    parseQueryParamLangOverride,
    getLangCodeForAudio
};
